import styled from 'styled-components';
import { Link } from 'react-router';
import { media } from '@styles/breakpoints';

export const FooterWrapper = styled.footer`
  width: 100%;
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.colors.navy[950]} 0%,
    #040d14 100%
  );
  color: ${({ theme }) => theme.semantic.text.inverse};
  padding-top: ${({ theme }) => theme.spacing[16]};
  padding-bottom: ${({ theme }) => theme.spacing[8]};
`;

export const FooterContainer = styled.div`
  max-width: ${({ theme }) => theme.layout.maxWidth};
  margin-inline: auto;
  padding-inline: ${({ theme }) => theme.spacing[5]};

  ${media.tablet} {
    padding-inline: ${({ theme }) => theme.spacing[8]};
  }

  ${media.desktop} {
    padding-inline: ${({ theme }) => theme.spacing[12]};
  }
`;

export const FooterTop = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.spacing[10]};
  padding-bottom: ${({ theme }) => theme.spacing[10]};
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);

  ${media.tablet} {
    grid-template-columns: 1.6fr 1fr 1fr;
  }

  ${media.desktop} {
    grid-template-columns: 2fr 1fr 1fr 1fr;
  }
`;

/* ── Coluna da marca ──────────────────────────── */

export const BrandColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[5]};
`;

export const BrandTagline = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: ${({ theme }) => theme.lineHeights.relaxed};
  color: rgba(255, 255, 255, 0.45);
  max-width: 36ch;
`;

export const SocialRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[3]};
`;

export const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: ${({ theme }) => theme.radii.sm};
  background-color: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.55);
  transition: background-color 0.2s ease, color 0.2s ease;
  font-size: 0.95rem;

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.semantic.brand.accent};
      color: ${({ theme }) => theme.colors.navy[900]};
    }
  }
`;

/* ── Colunas de links ─────────────────────────── */

export const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]};
`;

export const ColumnTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  letter-spacing: ${({ theme }) => theme.letterSpacings.widest};
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.35);
  margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const FooterLink = styled(Link)`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.2s ease;

  @media (hover: hover) {
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
`;

export const FooterExternalLink = styled.a`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.2s ease;

  @media (hover: hover) {
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
`;

/* ── Linha de contato ─────────────────────────── */

export const ContactItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const ContactLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: rgba(255, 255, 255, 0.3);
  letter-spacing: ${({ theme }) => theme.letterSpacings.wide};
  text-transform: uppercase;
`;

export const ContactValue = styled.a`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.2s ease;

  @media (hover: hover) {
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
`;

/* ── Rodapé inferior ──────────────────────────── */

export const FooterBottom = styled.div`
  padding-top: ${({ theme }) => theme.spacing[6]};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[3]};
  align-items: flex-start;

  ${media.tablet} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const Copyright = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: rgba(255, 255, 255, 0.25);
  line-height: ${({ theme }) => theme.lineHeights.normal};
`;

export const FooterBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[1]};
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: rgba(255, 255, 255, 0.2);
`;

export const AccentDot = styled.span`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.semantic.brand.accent};
  opacity: 0.7;
`;
